<div
  class="flex flex-col rounded-(--appointment-card-border-radius) bg-(--appointment-card-background) overflow-hidden"
  [class]="
    (config().border ? 'border border-(--appointment-card-border-color)' : '') +
    (config().shadow ? ' shadow-(--appointment-card-shadow)' : '')
  "
>
  <div
    class="flex flex-col gap-(--appointment-card-gap) px-(--appointment-card-padding-x) py-(--appointment-card-padding-y)"
  >
    @if (config().chipText) {
      <div class="w-fit">
        <app-dynamic
          componentName="Chip"
          [props]="{ config: { text: config().chipText!, variant: chipVariant() } }"
        />
      </div>
    }

    <div class="flex items-center gap-4 w-full">
      @if (config().avatarUrl || config().avatarInitials) {
        <app-dynamic
          componentName="Avatar"
          [props]="{ config: { size: 'lg', imageUrl: config().avatarUrl, initials: config().avatarInitials } }"
        />
      }

      <div class="flex flex-col flex-1 gap-2 min-w-0">
        <div class="flex items-center gap-2">
          <div class="flex flex-col">
            <app-dynamic
              componentName="DynamicText"
              [props]="{
                config: {
                  text: config().title1,
                  size: 'xl',
                  fontWeight: 'semibold',
                  whiteSpace: config().whiteSpace,
                  tag: 'h3',
                  cssVarPrefix: 'appointment-card-title',
                },
              }"
            />
            @if (config().title2) {
              <app-dynamic
                componentName="DynamicText"
                [props]="{
                  config: {
                    text: config().title2,
                    size: 'xl',
                    fontWeight: 'semibold',
                    whiteSpace: config().whiteSpace,
                    tag: 'h3',
                    cssVarPrefix: 'appointment-card-title',
                  },
                }"
              />
            }
          </div>
          @if (config().infoAction) {
            <app-dynamic
              componentName="IconButton"
              [props]="{
                config: {
                  icon: 'info',
                  size: 'md',
                  action: config().infoAction,
                  ariaLabel: 'Info',
                  cssVarPrefix: 'appointment-card-info-icon',
                },
              }"
              (action)="onButtonClick($event)"
            />
          }
        </div>
        @if (config().subtext) {
          <app-dynamic
            componentName="DynamicText"
            [props]="{
              config: {
                text: config().subtext,
                size: 'sm',
                fontWeight: 'bold',
                whiteSpace: config().whiteSpace,
                cssVarPrefix: 'appointment-card-subtext',
              },
            }"
          />
        }
      </div>
    </div>

    @if (config().secondaryButtons?.length || config().tertiaryButton) {
      <div class="flex flex-col gap-3">
        @for (item of config().secondaryButtons ?? []; track item.title) {
          <app-dynamic
            componentName="RowButton"
            [props]="{
              config: {
                variant: item.variant || 'secondary',
                border: item.border,
                leadingIcon: item.icon,
                title: item.title,
                supportingText: item.supportingText,
                showChevron: item.showChevron,
                action: item.action,
              },
            }"
            (action)="onButtonClick($event)"
          />
        }
        @if (config().tertiaryButton; as tertiaryButton) {
          <app-dynamic
            componentName="RowButton"
            [props]="{
              config: {
                variant: tertiaryButton.variant || 'primary',
                border: tertiaryButton.border,
                title: tertiaryButton.title,
                action: tertiaryButton.action,
                showChevron: tertiaryButton.showChevron,
              },
            }"
            (action)="onButtonClick($event)"
          />
        }
      </div>
    }
  </div>
</div>
